import { Axial } from '../game/map/HexCoordinates';

/**
 * Wycinka po drucie.
 *
 * Podróżuje jak drogi: **co wycięto w obszarze** przychodzi po HTTP razem
 * z ziemią, a **co właśnie zniknęło** — socketem (`treesFelled`). Chunki niosą
 * to samo, ale przeglądarka trzyma je minutami, więc lista jest kładziona na
 * to, co przyjechało, a nie zakładana w nim.
 */

const API = import.meta.env.VITE_API_URL ?? '';

/** Co serwer mówi przy starcie wycinki. */
export interface Started extends Axial {
  seconds: number;
  logs: number;
}

export interface Refused {
  code: string;
  message: string;
}

/** Wycięte pola w promieniu tylu pierścieni chunków od pola. */
export async function loadFelled(at: Axial, radius: number): Promise<Axial[]> {
  const response = await fetch(`${API}/api/world/felled/at?q=${at.q}&r=${at.r}&radius=${radius}`);
  if (!response.ok) {
    throw new Error(`wycinka: ${response.status}`);
  }
  return (await response.json()) as Axial[];
}

/** Zacznij wycinać drzewa na polu, przy którym się stoi. */
export async function fellTrees(token: string, cell: Axial): Promise<Started | Refused> {
  const response = await fetch(`${API}/api/world/fell`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify({ q: cell.q, r: cell.r }),
  });
  const body = await response.json().catch(() => ({ code: 'broken', message: 'brak odpowiedzi' }));
  return response.ok ? (body as Started) : (body as Refused);
}

/** Odłóż topór. Przerwana wycinka nie daje nic. */
export async function stopFelling(token: string): Promise<void> {
  await fetch(`${API}/api/world/fell`, {
    method: 'DELETE',
    headers: { Authorization: `Bearer ${token}` },
  });
}
